import axiosAutoCheck from "global/helpers/axiosAutoCheckIn";
import {
  MEDICO_POR_MATRICULA,
  MEDICO_POR_MATRICULA_FAIL,
  MEDICO_POR_MATRICULA_SUCCESS,
  SELECCIONA_MEDICO_LABO,
  SELECCIONA_MEDICO_LABO_FAIL,
  SELECCIONA_MEDICO_LABO_SUCCESS,
  SELECCIONA_MEDICO_TURNO,
  SELECCIONA_MEDICO_TURNO_FAIL,
  SELECCIONA_MEDICO_TURNO_SUCCESS,
} from "../ActionTypes";
import axiosLogin from "global/helpers/axiosLogin";

export const wsGetMedicoPorMatricula = (matricula, nextStep) => (dispatch) => {
  dispatch({ type: MEDICO_POR_MATRICULA });

  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/medico-solicitante/por-matricula/${matricula}`)
      .then((resp) => {
        dispatch({ type: MEDICO_POR_MATRICULA_SUCCESS, payload: resp.data });
        if (nextStep) {
          nextStep(true);
        }
      })
      .catch((err) => {
        dispatch({ type: MEDICO_POR_MATRICULA_FAIL, payload: err });
        if (nextStep) {
          nextStep(false);
        }
      });
  });
};

export const wsPutSeleccionarMedicoLabo =
  (idProtocolo, medSolicitante, idPacFamiliar, nextStep) => (dispatch) => {
    dispatch({ type: SELECCIONA_MEDICO_LABO });

    axiosLogin().then((respuesta) => {
      respuesta
        .put(
          // trim: el código viene de una columna CHAR(5), puede traer espacios
          // de relleno. encodeURIComponent: por si el código tuviera caracteres
          // especiales — sin codificar, el backend recibiría un valor distinto.
          `/his/medico-solicitante/laboratorio/matricula/${idProtocolo}/${encodeURIComponent(
            `${medSolicitante ?? ""}`.trim()
          )}/${!idPacFamiliar ? -1 : idPacFamiliar}`
        )
        .then((resp) => {
          dispatch({ type: SELECCIONA_MEDICO_LABO_SUCCESS });
          if (nextStep) {
            nextStep(true);
          }
        })
        .catch((err) => {
          dispatch({ type: SELECCIONA_MEDICO_LABO_FAIL });
          if (nextStep) {
            nextStep(false);
          }
        });
    });
  };

export const wsPutSeleccionaMedicoTurnoQr =
  (idTurno, medSolicitante, nextStep) => (dispatch) => {
    dispatch({ type: SELECCIONA_MEDICO_TURNO });

    axiosLogin().then((respuesta) => {
      respuesta
        .put(
          // trim: el código viene de una columna CHAR(5), puede traer espacios
          // de relleno. encodeURIComponent: por si el código tuviera caracteres
          // especiales — sin codificar, el backend recibiría un valor distinto.
          `/his/medico-solicitante/turno/matricula/${idTurno}/${encodeURIComponent(
            `${medSolicitante ?? ""}`.trim()
          )}`
        )
        .then((resp) => {
          dispatch({ type: SELECCIONA_MEDICO_TURNO_SUCCESS });
          if (nextStep) {
            nextStep(true);
          }
        })
        .catch((err) => {
          dispatch({ type: SELECCIONA_MEDICO_TURNO_FAIL });
          if (nextStep) {
            nextStep(false);
          }
        });
    });
  };
